declare var CustomerAPIUrl: any;

class CustomerAPIBase {
    protected transformOptions(options: JQueryAjaxSettings) {
        var jwt = localStorage.getItem("loginToken");
        options.headers["Content-Type"] = "application/json; charset=UTF-8";
        options.headers["Accept"] = "application/json; charset=UTF-8";
        options.headers["Authorization"] = 'Bearer ' + jwt;
        options.headers["X-Language"] = localizer.LangShortCode;

        return options;
    }
}
/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v9.11.6282.35315 (NJsonSchema v8.10.6282.29572) (http://NSwag.org)
// </auto-generated>
//----------------------

module CustomerAPI {

    export class AccountClient extends CustomerAPIBase {
        baseUrl: string | undefined = undefined;
        beforeSend: any = undefined;
        protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

        constructor(baseUrl?: string) {
            super();
            this.baseUrl = baseUrl !== undefined ? baseUrl : "";
        }

        getUser(onSuccess?: (result: WebUser) => void, onFail?: (exception: string, reason: string) => void) {
            let url_ = this.baseUrl + "/Account/User";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "get",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processGetUserWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processGetUserWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processGetUserWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processGetUser(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processGetUser(xhr: any): WebUser {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: WebUser | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 ? WebUser.fromJS(resultData200) : null;
                return result200;
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        setUserData(applicationName: string, value: WebUserChangeable, onSuccess?: () => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Account/SetUserData";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = JSON.stringify(value ? value.toJS() : null);

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "put",
                data: content_,
                dataType: "text",
                headers: {
                    "applicationName": applicationName,
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processSetUserDataWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processSetUserDataWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processSetUserDataWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processSetUserData(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processSetUserData(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        register(user: WebUserRegisterInfo, onSuccess?: () => void, onFail?: (exception: WebError | WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Account/Register";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = JSON.stringify(user ? user.toJS() : null);

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processRegisterWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processRegisterWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processRegisterWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processRegister(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processRegister(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 409) {
                let result409: WebError | null = null;
                let resultData409 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result409 = resultData409 ? WebError.fromJS(resultData409) : null;
                this.throwException("A server error occurred.", status, responseText, result409);
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        changePassword(changePassword: ChangePassword, onSuccess?: () => void, onFail?: (exception: string, reason: string) => void) {
            let url_ = this.baseUrl + "/Account/ChangePassword";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = JSON.stringify(changePassword ? changePassword.toJS() : null);

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processChangePasswordWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processChangePasswordWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processChangePasswordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processChangePassword(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processChangePassword(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 400) {
                this.throwException("A server error occurred.", status, responseText);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        forgotPassword(email: string, onSuccess?: () => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Account/ForgotPassword/{email}";
            if (email === undefined || email === null)
                throw new Error("The parameter 'email' must be defined.");
            url_ = url_.replace("{email}", encodeURIComponent("" + email));
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processForgotPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processForgotPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processForgotPasswordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processForgotPassword(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processForgotPassword(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        changePasswordFromResetGUID(resetData: ResetPassword, onSuccess?: () => void, onFail?: (exception: string, reason: string) => void) {
            let url_ = this.baseUrl + "/Account/ChangePasswordFromResetGUID";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = JSON.stringify(resetData ? resetData.toJS() : null);

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processChangePasswordFromResetGUIDWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processChangePasswordFromResetGUIDWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processChangePasswordFromResetGUIDWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processChangePasswordFromResetGUID(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processChangePasswordFromResetGUID(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 400) {
                this.throwException("A server error occurred.", status, responseText);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        renewToken(onSuccess?: (result: Token) => void, onFail?: (exception: string, reason: string) => void) {
            let url_ = this.baseUrl + "/Account/RenewToken";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processRenewTokenWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processRenewTokenWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processRenewTokenWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processRenewToken(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processRenewToken(xhr: any): Token {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: Token | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 ? Token.fromJS(resultData200) : new Token();
                return result200;
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        getEvents(onSuccess?: (result: Token) => void, onFail?: (exception: string, reason: string) => void) {
            let url_ = this.baseUrl + "/Account/GetEvents";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processGetEventsWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processGetEventsWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processGetEventsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processGetEvents(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processGetEvents(xhr: any): Token {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: Token | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 ? Token.fromJS(resultData200) : new Token();
                return result200;
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        protected throwException(message: string, status: number, response: string, result?: any): any {
            if (result !== null && result !== undefined)
                throw result;
            else
                throw new SwaggerException(message, status, response, null);
        }
    }

    export class DevicesClient extends CustomerAPIBase {
        baseUrl: string | undefined = undefined;
        beforeSend: any = undefined;
        protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

        constructor(baseUrl?: string) {
            super();
            this.baseUrl = baseUrl !== undefined ? baseUrl : "";
        }

        get(onSuccess?: (result: WebDevice[]) => void, onFail?: (exception: string, reason: string) => void) {
            let url_ = this.baseUrl + "/Devices";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "get",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processGet(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processGet(xhr: any): WebDevice[] {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: WebDevice[] | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(WebDevice.fromJS(item));
                }
                return result200;
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        update(value: WebDevice, onSuccess?: () => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Devices";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = JSON.stringify(value ? value.toJS() : null);

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "put",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processUpdateWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processUpdateWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processUpdateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processUpdate(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processUpdate(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        getMeasurements(imei: number, maxAge: number, maxResults: number, onSuccess?: (result: GetMeasurementsResponse) => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Devices/GetMeasurements?";
            if (imei === undefined || imei === null)
                throw new Error("The parameter 'imei' must be defined and cannot be null.");
            else
                url_ += "imei=" + encodeURIComponent("" + imei) + "&";
            if (maxAge === undefined || maxAge === null)
                throw new Error("The parameter 'maxAge' must be defined and cannot be null.");
            else
                url_ += "maxAge=" + encodeURIComponent("" + maxAge) + "&";
            if (maxResults === undefined)
                throw new Error("The parameter 'maxResults' must be defined.");
            else
                url_ += "maxResults=" + encodeURIComponent("" + maxResults) + "&";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "get",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processGetMeasurementsWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processGetMeasurementsWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processGetMeasurementsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processGetMeasurements(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processGetMeasurements(xhr: any): GetMeasurementsResponse {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: GetMeasurementsResponse | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetMeasurementsResponse.fromJS(resultData200) : null;
                return result200;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        delete(imei: number, onSuccess?: () => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Devices/{imei}";
            if (imei === undefined || imei === null)
                throw new Error("The parameter 'imei' must be defined.");
            url_ = url_.replace("{imei}", encodeURIComponent("" + imei));
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "delete",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processDelete(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processDelete(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        assignToUser(deviceIMEI: number, onSuccess?: (result: WebDevice) => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Devices/AssignToUser/{deviceIMEI}";
            if (deviceIMEI === undefined || deviceIMEI === null)
                throw new Error("The parameter 'deviceIMEI' must be defined.");
            url_ = url_.replace("{deviceIMEI}", encodeURIComponent("" + deviceIMEI));
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "put",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processAssignToUserWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processAssignToUserWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processAssignToUserWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processAssignToUser(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processAssignToUser(xhr: any): WebDevice {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: WebDevice | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 ? WebDevice.fromJS(resultData200) : null;
                return result200;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        getBatteryType(imei: number, onSuccess?: (result: WebBatteryType) => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Devices/BatteryType/{imei}";
            if (imei === undefined || imei === null)
                throw new Error("The parameter 'imei' must be defined.");
            url_ = url_.replace("{imei}", encodeURIComponent("" + imei));
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "get",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processGetBatteryTypeWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processGetBatteryTypeWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processGetBatteryTypeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processGetBatteryType(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processGetBatteryType(xhr: any): WebBatteryType {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: WebBatteryType | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 ? WebBatteryType.fromJS(resultData200) : null;
                return result200;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        setBatteryType(imei: number, type: WebBatteryType, onSuccess?: () => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Devices/BatteryType/{imei}";
            if (imei === undefined || imei === null)
                throw new Error("The parameter 'imei' must be defined.");
            url_ = url_.replace("{imei}", encodeURIComponent("" + imei));
            url_ = url_.replace(/[?&]$/, "");

            const content_ = JSON.stringify(type ? type.toJS() : null);

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processSetBatteryTypeWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processSetBatteryTypeWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processSetBatteryTypeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processSetBatteryType(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processSetBatteryType(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        getSupprotedBatteryTypes(onSuccess?: (result: WebBatteryType[]) => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Devices/SupportedBatteryTypes";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "get",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processGetSupprotedBatteryTypesWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processGetSupprotedBatteryTypesWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processGetSupprotedBatteryTypesWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processGetSupprotedBatteryTypes(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processGetSupprotedBatteryTypes(xhr: any): WebBatteryType[] {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: WebBatteryType[] | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(WebBatteryType.fromJS(item));
                }
                return result200;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        protected throwException(message: string, status: number, response: string, result?: any): any {
            if (result !== null && result !== undefined)
                throw result;
            else
                throw new SwaggerException(message, status, response, null);
        }
    }

    export class NotificationServiceClient extends CustomerAPIBase {
        baseUrl: string | undefined = undefined;
        beforeSend: any = undefined;
        protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

        constructor(baseUrl?: string) {
            super();
            this.baseUrl = baseUrl !== undefined ? baseUrl : "";
        }

        get(imei: string, onSuccess?: (result: GetTriggerResponse) => void, onFail?: (exception: string | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Notifications/{imei}";
            if (imei === undefined || imei === null)
                throw new Error("The parameter 'imei' must be defined.");
            url_ = url_.replace("{imei}", encodeURIComponent("" + imei));
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "get",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processGet(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processGet(xhr: any): GetTriggerResponse {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: GetTriggerResponse | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTriggerResponse.fromJS(resultData200) : null;
                return result200;
            } else if (status === 400) {
                let result400: string | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        post(trigger: Trigger, onSuccess?: (result: Trigger) => void, onFail?: (exception: string | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Notifications";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = JSON.stringify(trigger ? trigger.toJS() : null);

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processPostWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processPostWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processPostWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processPost(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processPost(xhr: any): Trigger {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: Trigger | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 ? Trigger.fromJS(resultData200) : null;
                return result200;
            } else if (status === 400) {
                let result400: string | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        put(id: number, trigger: Trigger, onSuccess?: (result: PutTriggerResponse) => void, onFail?: (exception: string | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Notifications/{id}";
            if (id === undefined || id === null)
                throw new Error("The parameter 'id' must be defined.");
            url_ = url_.replace("{id}", encodeURIComponent("" + id));
            url_ = url_.replace(/[?&]$/, "");

            const content_ = JSON.stringify(trigger ? trigger.toJS() : null);

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "put",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processPutWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processPutWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processPutWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processPut(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processPut(xhr: any): PutTriggerResponse {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 204) {
                let result204: PutTriggerResponse | null = null;
                let resultData204 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result204 = resultData204 ? PutTriggerResponse.fromJS(resultData204) : null;
                return result204;
            } else if (status === 400) {
                let result400: string | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        delete(id: number, onSuccess?: (result: DeleteTriggerResponse) => void, onFail?: (exception: string | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Notifications/{id}";
            if (id === undefined || id === null)
                throw new Error("The parameter 'id' must be defined.");
            url_ = url_.replace("{id}", encodeURIComponent("" + id));
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "delete",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processDelete(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processDelete(xhr: any): DeleteTriggerResponse {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: DeleteTriggerResponse | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 ? DeleteTriggerResponse.fromJS(resultData200) : null;
                return result200;
            } else if (status === 400) {
                let result400: string | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        event(secret: string, triggerEvent: TriggerEvent, onSuccess?: () => void, onFail?: (exception: string, reason: string) => void) {
            let url_ = this.baseUrl + "/Notifications/Event?";
            if (secret === undefined)
                throw new Error("The parameter 'secret' must be defined.");
            else
                url_ += "secret=" + encodeURIComponent("" + secret) + "&";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = JSON.stringify(triggerEvent ? triggerEvent.toJS() : null);

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processEventWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processEventWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processEventWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processEvent(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processEvent(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 401) {
                this.throwException("A server error occurred.", status, responseText);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        protected throwException(message: string, status: number, response: string, result?: any): any {
            if (result !== null && result !== undefined)
                throw result;
            else
                throw new SwaggerException(message, status, response, null);
        }
    }

    export class PaymentClient extends CustomerAPIBase {
        baseUrl: string | undefined = undefined;
        beforeSend: any = undefined;
        protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

        constructor(baseUrl?: string) {
            super();
            this.baseUrl = baseUrl !== undefined ? baseUrl : "";
        }

        getAll(onSuccess?: (result: WebPayment[]) => void, onFail?: (exception: string, reason: string) => void) {
            let url_ = this.baseUrl + "/api/Payment";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "get",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processGetAll(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processGetAll(xhr: any): WebPayment[] {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: WebPayment[] | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(WebPayment.fromJS(item));
                }
                return result200;
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        post(value: WebPurchase, onSuccess?: (result: any) => void, onFail?: (exception: string, reason: string) => void) {
            let url_ = this.baseUrl + "/api/Payment";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = JSON.stringify(value ? value.toJS() : null);

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processPostWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processPostWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processPostWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processPost(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processPost(xhr: any): any {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: any | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        get(id: number, onSuccess?: (result: WebPayment) => void, onFail?: (exception: string, reason: string) => void) {
            let url_ = this.baseUrl + "/api/Payment/{id}";
            if (id === undefined || id === null)
                throw new Error("The parameter 'id' must be defined.");
            url_ = url_.replace("{id}", encodeURIComponent("" + id));
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "get",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processGet(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processGet(xhr: any): WebPayment {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: WebPayment | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 ? WebPayment.fromJS(resultData200) : null;
                return result200;
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        protected throwException(message: string, status: number, response: string, result?: any): any {
            if (result !== null && result !== undefined)
                throw result;
            else
                throw new SwaggerException(message, status, response, null);
        }
    }

    export class ScriptGeneratorClient extends CustomerAPIBase {
        baseUrl: string | undefined = undefined;
        beforeSend: any = undefined;
        protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

        constructor(baseUrl?: string) {
            super();
            this.baseUrl = baseUrl !== undefined ? baseUrl : "";
        }

        getTypeScript(onSuccess?: (result: any) => void, onFail?: (exception: string, reason: string) => void) {
            let url_ = this.baseUrl + "/api/ScriptGenerator/TypeScript";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "get",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processGetTypeScriptWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processGetTypeScriptWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processGetTypeScriptWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processGetTypeScript(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processGetTypeScript(xhr: any): any {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: any | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        protected throwException(message: string, status: number, response: string, result?: any): any {
            if (result !== null && result !== undefined)
                throw result;
            else
                throw new SwaggerException(message, status, response, null);
        }
    }

    export class SubscriptionsClient extends CustomerAPIBase {
        baseUrl: string | undefined = undefined;
        beforeSend: any = undefined;
        protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

        constructor(baseUrl?: string) {
            super();
            this.baseUrl = baseUrl !== undefined ? baseUrl : "";
        }

        getSetupIntent(): JQueryPromise<string> {
            let url_ = this.baseUrl + "/card/setup-intent";

            return jQuery.ajax(this.transformOptions({
                url: url_,
                type: "get",
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            }));
        }

        confirmSetupIntent(intent: any): JQueryPromise<void> {
            let url_ = this.baseUrl + "/card/confirm-intent";
            var content = JSON.stringify(intent ? intent : null);

            return jQuery.ajax(this.transformOptions({
                url: url_,
                type: "post",
                data: content,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            }));
        }

        getSubscription(imei: number, onSuccess?: (result: WebSubscription) => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Subscriptions/{imei}";
            if (imei === undefined || imei === null)
                throw new Error("The parameter 'imei' must be defined.");
            url_ = url_.replace("{imei}", encodeURIComponent("" + imei));
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "get",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processGetSubscriptionWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processGetSubscriptionWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processGetSubscriptionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processGetSubscription(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processGetSubscription(xhr: any): WebSubscription {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: WebSubscription | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 ? WebSubscription.fromJS(resultData200) : null;
                return result200;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        stopSubscription(imei: number, onSuccess?: () => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Subscriptions/{imei}";
            if (imei === undefined || imei === null)
                throw new Error("The parameter 'imei' must be defined.");
            url_ = url_.replace("{imei}", encodeURIComponent("" + imei));
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "delete",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processStopSubscriptionWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processStopSubscriptionWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processStopSubscriptionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processStopSubscription(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processStopSubscription(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        removePaymentCards(onSuccess?: () => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Subscriptions/RemovePaymentCards";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processRemovePaymentCardsWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processRemovePaymentCardsWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processRemovePaymentCardsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processRemovePaymentCards(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processRemovePaymentCards(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        stripeCreateCustomer(onSuccess?: () => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Subscriptions/CreateStripeCustomer";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processStripeCreateCustomerWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processStripeCreateCustomerWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processStripeCreateCustomerWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processStripeCreateCustomer(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processStripeCreateCustomer(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        stripeStartRecurring(imei: number, onSuccess?: (result: WebStartRecurringResult) => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Subscriptions/StartStripeRecurring/{imei}";
            if (imei === undefined || imei === null)
                throw new Error("The parameter 'imei' must be defined.");
            url_ = url_.replace("{imei}", encodeURIComponent("" + imei));
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processStripeStartRecurringWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processStripeStartRecurringWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processStripeStartRecurringWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processStripeStartRecurring(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processStripeStartRecurring(xhr: any): WebStartRecurringResult {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                let result200: WebStartRecurringResult | null = null;
                let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result200 = resultData200 ? WebStartRecurringResult.fromJS(resultData200) : null;
                return result200;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        stripeChangeCard(data: StripeCardData, onSuccess?: () => void, onFail?: (exception: WebError | string, reason: string) => void) {
            let url_ = this.baseUrl + "/Subscriptions/ChangeStripeCard";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = JSON.stringify(data ? data.toJS() : null);

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processStripeChangeCardWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processStripeChangeCardWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processStripeChangeCardWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processStripeChangeCard(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processStripeChangeCard(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status === 400) {
                let result400: WebError | null = null;
                let resultData400 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
                result400 = resultData400 ? WebError.fromJS(resultData400) : null;
                this.throwException("A server error occurred.", status, responseText, result400);
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        stripeEvent(onSuccess?: () => void, onFail?: (exception: string, reason: string) => void) {
            let url_ = this.baseUrl + "/Subscriptions/StripeEvent";
            url_ = url_.replace(/[?&]$/, "");

            const content_ = "";

            jQuery.ajax(this.transformOptions({
                url: url_,
                beforeSend: this.beforeSend,
                type: "post",
                data: content_,
                dataType: "text",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json; charset=UTF-8"
                }
            })).done((data, textStatus, xhr) => {
                this.processStripeEventWithCallbacks(url_, xhr, onSuccess, onFail);
            }).fail((xhr) => {
                this.processStripeEventWithCallbacks(url_, xhr, onSuccess, onFail);
            });
        }

        private processStripeEventWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
            try {
                let result = this.processStripeEvent(xhr);
                if (onSuccess !== undefined)
                    onSuccess(result);
            } catch (e) {
                if (onFail !== undefined)
                    onFail(e, "http_service_exception");
            }
        }

        protected processStripeEvent(xhr: any): void {
            const responseText = xhr.responseText;
            const status = xhr.status;

            if (status === 200) {
                return null;
            } else if (status !== 200 && status !== 204) {
                this.throwException("An unexpected server error occurred.", status, responseText);
            }
            return null;
        }

        protected throwException(message: string, status: number, response: string, result?: any): any {
            if (result !== null && result !== undefined)
                throw result;
            else
                throw new SwaggerException(message, status, response, null);
        }
    }

    export class WebUserChangeable {
        email: string | null | undefined;
        name: string | null | undefined;
        countryCode: number | undefined;
        phoneNumber: string | null | undefined;
        address: string | null | undefined;
        born: Date | undefined;
        sex: Sex | undefined;
        receiveNewsletterPhone: boolean | undefined;
        receiveNewsletterMail: boolean | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.email = data["email"] !== undefined ? data["email"] : undefined;
                this.name = data["name"] !== undefined ? data["name"] : undefined;
                this.countryCode = data["countryCode"] !== undefined ? data["countryCode"] : undefined;
                this.phoneNumber = data["phoneNumber"] !== undefined ? data["phoneNumber"] : undefined;
                this.address = data["address"] !== undefined ? data["address"] : undefined;
                this.born = data["born"] ? new Date(data["born"].toString()) : undefined;
                this.sex = data["sex"] !== undefined ? data["sex"] : undefined;
                this.receiveNewsletterPhone = data["receiveNewsletterPhone"] !== undefined ? data["receiveNewsletterPhone"] : undefined;
                this.receiveNewsletterMail = data["receiveNewsletterMail"] !== undefined ? data["receiveNewsletterMail"] : undefined;
            }
        }

        static fromJS(data: any): WebUserChangeable {
            return new WebUserChangeable(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["email"] = this.email !== undefined ? this.email : undefined;
            data["name"] = this.name !== undefined ? this.name : undefined;
            data["countryCode"] = this.countryCode !== undefined ? this.countryCode : undefined;
            data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : undefined;
            data["address"] = this.address !== undefined ? this.address : undefined;
            data["born"] = this.born ? this.born.toISOString() : undefined;
            data["sex"] = this.sex !== undefined ? this.sex : undefined;
            data["receiveNewsletterPhone"] = this.receiveNewsletterPhone !== undefined ? this.receiveNewsletterPhone : undefined;
            data["receiveNewsletterMail"] = this.receiveNewsletterMail !== undefined ? this.receiveNewsletterMail : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new WebUserChangeable(JSON.parse(json));
        }
    }

    export class WebUser extends WebUserChangeable {
        subscriptionType: PaymentType | undefined;
        devices: WebDevice[] | null | undefined;
        events: WebEventHistory[] | null | undefined;
        smsBalance: number | undefined;
        smsSent: number | undefined;
        paymentCardNumber: string | null | undefined;
        payments: WebPayment[] | null | undefined;

        constructor(data?: any) {
            super(data);
            if (data !== undefined) {
                this.subscriptionType = data["subscriptionType"] !== undefined ? data["subscriptionType"] : undefined;
                if (data["devices"] && data["devices"].constructor === Array) {
                    this.devices = [];
                    for (let item of data["devices"])
                        this.devices.push(WebDevice.fromJS(item));
                }
                if (data["events"] && data["events"].constructor === Array) {
                    this.events = [];
                    for (let item of data["events"])
                        this.events.push(WebEventHistory.fromJS(item));
                }
                this.smsBalance = data["smsBalance"] !== undefined ? data["smsBalance"] : undefined;
                this.smsSent = data["smsSent"] !== undefined ? data["smsSent"] : undefined;
                this.paymentCardNumber = data["paymentCardNumber"] !== undefined ? data["paymentCardNumber"] : undefined;
                if (data["payments"] && data["payments"].constructor === Array) {
                    this.payments = [];
                    for (let item of data["payments"])
                        this.payments.push(WebPayment.fromJS(item));
                }
            }
        }

        static fromJS(data: any): WebUser {
            return new WebUser(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["subscriptionType"] = this.subscriptionType !== undefined ? this.subscriptionType : undefined;
            if (this.devices && this.devices.constructor === Array) {
                data["devices"] = [];
                for (let item of this.devices)
                    data["devices"].push(item.toJS());
            }
            if (this.events && this.events.constructor === Array) {
                data["events"] = [];
                for (let item of this.events)
                    data["events"].push(item.toJS());
            }
            data["smsBalance"] = this.smsBalance !== undefined ? this.smsBalance : undefined;
            data["smsSent"] = this.smsSent !== undefined ? this.smsSent : undefined;
            data["paymentCardNumber"] = this.paymentCardNumber !== undefined ? this.paymentCardNumber : undefined;
            if (this.payments && this.payments.constructor === Array) {
                data["payments"] = [];
                for (let item of this.payments)
                    data["payments"].push(item.toJS());
            }
            super.toJS(data);
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new WebUser(JSON.parse(json));
        }
    }

    export enum PaymentType {
        None = 0,
        Stripe = 1,
    }

    export class WebDevice {
        imei: number | undefined;
        name: string | null | undefined;
        notificationLow: number | undefined;
        notificationHigh: number | undefined;
        notificationEmail: string | null | undefined;
        notificationPhoneNumber: string | null | undefined;
        isActive: boolean | undefined;
        expirationDate: Date | undefined;
        hasSubscription: boolean | undefined;
        subscription: WebSubscription | null | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.imei = data["imei"] !== undefined ? data["imei"] : undefined;
                this.name = data["name"] !== undefined ? data["name"] : undefined;
                this.notificationLow = data["notificationLow"] !== undefined ? data["notificationLow"] : undefined;
                this.notificationHigh = data["notificationHigh"] !== undefined ? data["notificationHigh"] : undefined;
                this.notificationEmail = data["notificationEmail"] !== undefined ? data["notificationEmail"] : undefined;
                this.notificationPhoneNumber = data["notificationPhoneNumber"] !== undefined ? data["notificationPhoneNumber"] : undefined;
                this.isActive = data["isActive"] !== undefined ? data["isActive"] : undefined;
                this.expirationDate = data["expirationDate"] ? new Date(data["expirationDate"].toString()) : undefined;
                this.hasSubscription = data["hasSubscription"] !== undefined ? data["hasSubscription"] : undefined;
                this.subscription = data["subscription"] ? WebSubscription.fromJS(data["subscription"]) : undefined;
            }
        }

        static fromJS(data: any): WebDevice {
            return new WebDevice(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["imei"] = this.imei !== undefined ? this.imei : undefined;
            data["name"] = this.name !== undefined ? this.name : undefined;
            data["notificationLow"] = this.notificationLow !== undefined ? this.notificationLow : undefined;
            data["notificationHigh"] = this.notificationHigh !== undefined ? this.notificationHigh : undefined;
            data["notificationEmail"] = this.notificationEmail !== undefined ? this.notificationEmail : undefined;
            data["notificationPhoneNumber"] = this.notificationPhoneNumber !== undefined ? this.notificationPhoneNumber : undefined;
            data["isActive"] = this.isActive !== undefined ? this.isActive : undefined;
            data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined;
            data["hasSubscription"] = this.hasSubscription !== undefined ? this.hasSubscription : undefined;
            data["subscription"] = this.subscription ? this.subscription.toJS() : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new WebDevice(JSON.parse(json));
        }
    }

    export class WebSubscription {
        subscriptionID: string | null | undefined;
        imei: number | undefined;
        subscriptionType: PaymentType | undefined;
        renewalDate: Date | undefined;
        created: Date | undefined;
        price: number | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.subscriptionID = data["subscriptionID"] !== undefined ? data["subscriptionID"] : undefined;
                this.imei = data["imei"] !== undefined ? data["imei"] : undefined;
                this.subscriptionType = data["subscriptionType"] !== undefined ? data["subscriptionType"] : undefined;
                this.renewalDate = data["renewalDate"] ? new Date(data["renewalDate"].toString()) : undefined;
                this.created = data["created"] ? new Date(data["created"].toString()) : undefined;
                this.price = data["price"] !== undefined ? data["price"] : undefined;
            }
        }

        static fromJS(data: any): WebSubscription {
            return new WebSubscription(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["subscriptionID"] = this.subscriptionID !== undefined ? this.subscriptionID : undefined;
            data["imei"] = this.imei !== undefined ? this.imei : undefined;
            data["subscriptionType"] = this.subscriptionType !== undefined ? this.subscriptionType : undefined;
            data["renewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : undefined;
            data["created"] = this.created ? this.created.toISOString() : undefined;
            data["price"] = this.price !== undefined ? this.price : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new WebSubscription(JSON.parse(json));
        }
    }

    export class WebEventHistory {
        userID: number | undefined;
        eventType: EventHistoryType | undefined;
        eventDate: Date | undefined;
        data: string | null | undefined;
        eventFrom: string | null | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.userID = data["userID"] !== undefined ? data["userID"] : undefined;
                this.eventType = data["eventType"] !== undefined ? data["eventType"] : undefined;
                this.eventDate = data["eventDate"] ? new Date(data["eventDate"].toString()) : undefined;
                this.data = data["data"] !== undefined ? data["data"] : undefined;
                this.eventFrom = data["eventFrom"] !== undefined ? data["eventFrom"] : undefined;
            }
        }

        static fromJS(data: any): WebEventHistory {
            return new WebEventHistory(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["userID"] = this.userID !== undefined ? this.userID : undefined;
            data["eventType"] = this.eventType !== undefined ? this.eventType : undefined;
            data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : undefined;
            data["data"] = this.data !== undefined ? this.data : undefined;
            data["eventFrom"] = this.eventFrom !== undefined ? this.eventFrom : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new WebEventHistory(JSON.parse(json));
        }
    }

    export enum EventHistoryType {
        ConcentReceiveMailChange = 0,
        ConcentReceivePhoneChange = 1,
        ConcentMailAddressChange = 2,
        ConcentPhoneNumberChange = 3,
        StripeCustomerCreated = 4,
        StripeCardChanged = 5,
        StripeReceivePayment = 6,
        StripeAddDeviceSubscription = 7,
        StripeRemoveDeviceSubscription = 8,
        StripeCharge = 9,
        ActivateDevice = 10,
        DeactivateDevice = 11,
    }

    export class WebPayment {
        id: number | undefined;
        product: Product | undefined;
        totalSum: number | undefined;
        amount: number | undefined;
        paymentType: PaymentType | undefined;
        isPaymentCompleted: boolean | undefined;
        purchaseTime: Date | undefined;
        paymentReceivedTime: Date | null | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.id = data["id"] !== undefined ? data["id"] : undefined;
                this.product = data["product"] !== undefined ? data["product"] : undefined;
                this.totalSum = data["totalSum"] !== undefined ? data["totalSum"] : undefined;
                this.amount = data["amount"] !== undefined ? data["amount"] : undefined;
                this.paymentType = data["paymentType"] !== undefined ? data["paymentType"] : undefined;
                this.isPaymentCompleted = data["isPaymentCompleted"] !== undefined ? data["isPaymentCompleted"] : undefined;
                this.purchaseTime = data["purchaseTime"] ? new Date(data["purchaseTime"].toString()) : undefined;
                this.paymentReceivedTime = data["paymentReceivedTime"] ? new Date(data["paymentReceivedTime"].toString()) : undefined;
            }
        }

        static fromJS(data: any): WebPayment {
            return new WebPayment(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["id"] = this.id !== undefined ? this.id : undefined;
            data["product"] = this.product !== undefined ? this.product : undefined;
            data["totalSum"] = this.totalSum !== undefined ? this.totalSum : undefined;
            data["amount"] = this.amount !== undefined ? this.amount : undefined;
            data["paymentType"] = this.paymentType !== undefined ? this.paymentType : undefined;
            data["isPaymentCompleted"] = this.isPaymentCompleted !== undefined ? this.isPaymentCompleted : undefined;
            data["purchaseTime"] = this.purchaseTime ? this.purchaseTime.toISOString() : undefined;
            data["paymentReceivedTime"] = this.paymentReceivedTime ? this.paymentReceivedTime.toISOString() : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new WebPayment(JSON.parse(json));
        }
    }

    export enum Product {
        SmsPackage = 0,
        StripeSubscription = 1,
    }

    export enum Sex {
        Male = 0,
        Female = 1,
    }

    export class WebError {
        error: ErrorType | undefined;
        message: string | null | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.error = data["error"] !== undefined ? data["error"] : undefined;
                this.message = data["message"] !== undefined ? data["message"] : undefined;
            }
        }

        static fromJS(data: any): WebError {
            return new WebError(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["error"] = this.error !== undefined ? this.error : undefined;
            data["message"] = this.message !== undefined ? this.message : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new WebError(JSON.parse(json));
        }
    }

    export enum ErrorType {
        LoginWrongPasswordOrUsername = 0,
        Other = 1,
        Exception = 2,
        Ok = 3,
    }

    export class WebUserRegisterInfo {
        email: string | null | undefined;
        name: string | null | undefined;
        password: string | null | undefined;
        imei: number | undefined;
        stripeToken: string | null | undefined;
        paymentMethodId: string | null | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.email = data["email"] !== undefined ? data["email"] : undefined;
                this.name = data["name"] !== undefined ? data["name"] : undefined;
                this.password = data["password"] !== undefined ? data["password"] : undefined;
                this.imei = data["imei"] !== undefined ? data["imei"] : undefined;
                this.stripeToken = data["stripeToken"] !== undefined ? data["stripeToken"] : undefined;
                this.paymentMethodId = data["paymentMethodId"] !== undefined ? data["paymentMethodId"] : undefined;
            }
        }

        static fromJS(data: any): WebUserRegisterInfo {
            return new WebUserRegisterInfo(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["email"] = this.email !== undefined ? this.email : undefined;
            data["name"] = this.name !== undefined ? this.name : undefined;
            data["password"] = this.password !== undefined ? this.password : undefined;
            data["imei"] = this.imei !== undefined ? this.imei : undefined;
            data["stripeToken"] = this.stripeToken !== undefined ? this.stripeToken : undefined;
            data["paymentMethodId"] = this.paymentMethodId !== undefined ? this.paymentMethodId: undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new WebUserRegisterInfo(JSON.parse(json));
        }
    }

    export class ChangePassword {
        oldPassword: string | null | undefined;
        newPassword: string | null | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.oldPassword = data["oldPassword"] !== undefined ? data["oldPassword"] : undefined;
                this.newPassword = data["newPassword"] !== undefined ? data["newPassword"] : undefined;
            }
        }

        static fromJS(data: any): ChangePassword {
            return new ChangePassword(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["oldPassword"] = this.oldPassword !== undefined ? this.oldPassword : undefined;
            data["newPassword"] = this.newPassword !== undefined ? this.newPassword : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new ChangePassword(JSON.parse(json));
        }
    }

    export class ResetPassword {
        email: string | null | undefined;
        newPassword: string | null | undefined;
        resetGuid: string | null | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.email = data["email"] !== undefined ? data["email"] : undefined;
                this.newPassword = data["newPassword"] !== undefined ? data["newPassword"] : undefined;
                this.resetGuid = data["resetGuid"] !== undefined ? data["resetGuid"] : undefined;
            }
        }

        static fromJS(data: any): ResetPassword {
            return new ResetPassword(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["email"] = this.email !== undefined ? this.email : undefined;
            data["newPassword"] = this.newPassword !== undefined ? this.newPassword : undefined;
            data["resetGuid"] = this.resetGuid !== undefined ? this.resetGuid : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new ResetPassword(JSON.parse(json));
        }
    }

    export class ValueType {

        constructor(data?: any) {
            if (data !== undefined) {
            }
        }

        static fromJS(data: any): ValueType {
            return new ValueType(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new ValueType(JSON.parse(json));
        }
    }

    export class Token extends ValueType {
        access_token: string | null | undefined;
        expires_in: number | undefined;

        constructor(data?: any) {
            super(data);
            if (data !== undefined) {
                this.access_token = data["access_token"] !== undefined ? data["access_token"] : undefined;
                this.expires_in = data["expires_in"] !== undefined ? data["expires_in"] : undefined;
            }
        }

        static fromJS(data: any): Token {
            return new Token(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["access_token"] = this.access_token !== undefined ? this.access_token : undefined;
            data["expires_in"] = this.expires_in !== undefined ? this.expires_in : undefined;
            super.toJS(data);
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new Token(JSON.parse(json));
        }
    }

    export class GetMeasurementsResponse {
        measurementList: MeasurementDTO[] | null | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                if (data["measurementList"] && data["measurementList"].constructor === Array) {
                    this.measurementList = [];
                    for (let item of data["measurementList"])
                        this.measurementList.push(MeasurementDTO.fromJS(item));
                }
            }
        }

        static fromJS(data: any): GetMeasurementsResponse {
            return new GetMeasurementsResponse(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            if (this.measurementList && this.measurementList.constructor === Array) {
                data["measurementList"] = [];
                for (let item of this.measurementList)
                    data["measurementList"].push(item.toJS());
            }
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new GetMeasurementsResponse(JSON.parse(json));
        }
    }

    export class MeasurementDTO {
        imei: string | null | undefined;
        geoLocation: GeoLocation | null | undefined;
        voltage1: number | undefined;
        temp: number | undefined;
        created: Date | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.imei = data["imei"] !== undefined ? data["imei"] : undefined;
                this.geoLocation = data["geoLocation"] ? GeoLocation.fromJS(data["geoLocation"]) : undefined;
                this.voltage1 = data["voltage1"] !== undefined ? data["voltage1"] : undefined;
                this.temp = data["temp"] !== undefined ? data["temp"] : undefined;
                this.created = data["created"] ? new Date(data["created"].toString()) : undefined;
            }
        }

        static fromJS(data: any): MeasurementDTO {
            return new MeasurementDTO(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["imei"] = this.imei !== undefined ? this.imei : undefined;
            data["geoLocation"] = this.geoLocation ? this.geoLocation.toJS() : undefined;
            data["voltage1"] = this.voltage1 !== undefined ? this.voltage1 : undefined;
            data["temp"] = this.temp !== undefined ? this.temp : undefined;
            data["created"] = this.created ? this.created.toISOString() : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new MeasurementDTO(JSON.parse(json));
        }
    }

    export class GeoLocation {
        longitude: number | undefined;
        latitude: number | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.longitude = data["longitude"] !== undefined ? data["longitude"] : undefined;
                this.latitude = data["latitude"] !== undefined ? data["latitude"] : undefined;
            }
        }

        static fromJS(data: any): GeoLocation {
            return new GeoLocation(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["longitude"] = this.longitude !== undefined ? this.longitude : undefined;
            data["latitude"] = this.latitude !== undefined ? this.latitude : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new GeoLocation(JSON.parse(json));
        }
    }

    export class WebBatteryType {
        id: number | undefined;
        name: string | null | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.id = data["id"] !== undefined ? data["id"] : undefined;
                this.name = data["name"] !== undefined ? data["name"] : undefined;
            }
        }

        static fromJS(data: any): WebBatteryType {
            return new WebBatteryType(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["id"] = this.id !== undefined ? this.id : undefined;
            data["name"] = this.name !== undefined ? this.name : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new WebBatteryType(JSON.parse(json));
        }
    }

    export class GetTriggerResponse {
        responseStatusCode: HttpStatusCode | undefined;
        triggers: Trigger[] | null | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.responseStatusCode = data["responseStatusCode"] !== undefined ? data["responseStatusCode"] : undefined;
                if (data["triggers"] && data["triggers"].constructor === Array) {
                    this.triggers = [];
                    for (let item of data["triggers"])
                        this.triggers.push(Trigger.fromJS(item));
                }
            }
        }

        static fromJS(data: any): GetTriggerResponse {
            return new GetTriggerResponse(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["responseStatusCode"] = this.responseStatusCode !== undefined ? this.responseStatusCode : undefined;
            if (this.triggers && this.triggers.constructor === Array) {
                data["triggers"] = [];
                for (let item of this.triggers)
                    data["triggers"].push(item.toJS());
            }
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new GetTriggerResponse(JSON.parse(json));
        }
    }

    export enum HttpStatusCode {
        Continue = 100,
        SwitchingProtocols = 101,
        OK = 200,
        Created = 201,
        Accepted = 202,
        NonAuthoritativeInformation = 203,
        NoContent = 204,
        ResetContent = 205,
        PartialContent = 206,
        MultipleChoices = 300,
        Ambiguous = 300,
        MovedPermanently = 301,
        Moved = 301,
        Found = 302,
        Redirect = 302,
        SeeOther = 303,
        RedirectMethod = 303,
        NotModified = 304,
        UseProxy = 305,
        Unused = 306,
        TemporaryRedirect = 307,
        RedirectKeepVerb = 307,
        BadRequest = 400,
        Unauthorized = 401,
        PaymentRequired = 402,
        Forbidden = 403,
        NotFound = 404,
        MethodNotAllowed = 405,
        NotAcceptable = 406,
        ProxyAuthenticationRequired = 407,
        RequestTimeout = 408,
        Conflict = 409,
        Gone = 410,
        LengthRequired = 411,
        PreconditionFailed = 412,
        RequestEntityTooLarge = 413,
        RequestUriTooLong = 414,
        UnsupportedMediaType = 415,
        RequestedRangeNotSatisfiable = 416,
        ExpectationFailed = 417,
        UpgradeRequired = 426,
        InternalServerError = 500,
        NotImplemented = 501,
        BadGateway = 502,
        ServiceUnavailable = 503,
        GatewayTimeout = 504,
        HttpVersionNotSupported = 505,
    }

    export class Trigger {
        id: number | undefined;
        unitId: string | null | undefined;
        unitName: string | null | undefined;
        triggerType: string | null | undefined;
        emailAddress: string | null | undefined;
        phoneNumber: string | null | undefined;
        minValue: number | undefined;
        maxValue: number | undefined;
        valueSuffix: string | null | undefined;
        action: ActionType | undefined;
        webHookUrl: string | null | undefined;
        language: string | null | undefined;
        isEnabled: boolean | undefined;

        useCustomNotification: boolean | undefined;
        customNotificationText: string | null | undefined;
        showValueInCustomNotification: boolean | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.id = data["id"] !== undefined ? data["id"] : undefined;
                this.unitId = data["unitId"] !== undefined ? data["unitId"] : undefined;
                this.unitName = data["unitName"] !== undefined ? data["unitName"] : undefined;
                this.triggerType = data["triggerType"] !== undefined ? data["triggerType"] : undefined;
                this.emailAddress = data["emailAddress"] !== undefined ? data["emailAddress"] : undefined;
                this.phoneNumber = data["phoneNumber"] !== undefined ? data["phoneNumber"] : undefined;
                this.minValue = data["minValue"] !== undefined ? data["minValue"] : undefined;
                this.maxValue = data["maxValue"] !== undefined ? data["maxValue"] : undefined;
                this.valueSuffix = data["valueSuffix"] !== undefined ? data["valueSuffix"] : undefined;
                this.action = data["action"] !== undefined ? data["action"] : undefined;
                this.webHookUrl = data["webHookUrl"] !== undefined ? data["webHookUrl"] : undefined;
                this.language = data["language"] !== undefined ? data["language"] : undefined;
                this.isEnabled = data["isEnabled"] !== undefined ? data["isEnabled"] : undefined;

                this.useCustomNotification = data["useCustomNotification"] !== undefined ? data["useCustomNotification"] : undefined;
                this.customNotificationText = data["customNotificationText"] !== undefined ? data["customNotificationText"] : undefined;
                this.showValueInCustomNotification = data["showValueInCustomNotification"] !== undefined ? data["showValueInCustomNotification"] : undefined;
            }
        }

        static fromJS(data: any): Trigger {
            return new Trigger(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["id"] = this.id !== undefined ? this.id : undefined;
            data["unitId"] = this.unitId !== undefined ? this.unitId : undefined;
            data["unitName"] = this.unitName !== undefined ? this.unitName : undefined;
            data["triggerType"] = this.triggerType !== undefined ? this.triggerType : undefined;
            data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : undefined;
            data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : undefined;
            data["minValue"] = this.minValue !== undefined ? this.minValue : undefined;
            data["maxValue"] = this.maxValue !== undefined ? this.maxValue : undefined;
            data["valueSuffix"] = this.valueSuffix !== undefined ? this.valueSuffix : undefined;
            data["action"] = this.action !== undefined ? this.action : undefined;
            data["webHookUrl"] = this.webHookUrl !== undefined ? this.webHookUrl : undefined;
            data["language"] = this.language !== undefined ? this.language : undefined;
            data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : undefined;

            data["useCustomNotification"] = this.useCustomNotification !== undefined ? this.useCustomNotification : undefined;
            data["customNotificationText"] = this.customNotificationText !== undefined ? this.customNotificationText : undefined;
            data["showValueInCustomNotification"] = this.showValueInCustomNotification !== undefined ? this.showValueInCustomNotification : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new Trigger(JSON.parse(json));
        }
    }

    export enum ActionType {
        None = 0,
        Mail = 1,
        Sms = 2,
    }

    export class PutTriggerResponse {
        responseStatusCode: HttpStatusCode | undefined;
        trigger: Trigger | null | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.responseStatusCode = data["responseStatusCode"] !== undefined ? data["responseStatusCode"] : undefined;
                this.trigger = data["trigger"] ? Trigger.fromJS(data["trigger"]) : undefined;
            }
        }

        static fromJS(data: any): PutTriggerResponse {
            return new PutTriggerResponse(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["responseStatusCode"] = this.responseStatusCode !== undefined ? this.responseStatusCode : undefined;
            data["trigger"] = this.trigger ? this.trigger.toJS() : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new PutTriggerResponse(JSON.parse(json));
        }
    }

    export class DeleteTriggerResponse {
        responseStatusCode: HttpStatusCode | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.responseStatusCode = data["responseStatusCode"] !== undefined ? data["responseStatusCode"] : undefined;
            }
        }

        static fromJS(data: any): DeleteTriggerResponse {
            return new DeleteTriggerResponse(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["responseStatusCode"] = this.responseStatusCode !== undefined ? this.responseStatusCode : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new DeleteTriggerResponse(JSON.parse(json));
        }
    }

    export class TriggerEvent {
        trigger: Trigger | null | undefined;
        triggerValue: number | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.trigger = data["trigger"] ? Trigger.fromJS(data["trigger"]) : undefined;
                this.triggerValue = data["triggerValue"] !== undefined ? data["triggerValue"] : undefined;
            }
        }

        static fromJS(data: any): TriggerEvent {
            return new TriggerEvent(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["trigger"] = this.trigger ? this.trigger.toJS() : undefined;
            data["triggerValue"] = this.triggerValue !== undefined ? this.triggerValue : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new TriggerEvent(JSON.parse(json));
        }
    }

    export class WebPurchase {
        product: Product | undefined;
        amount: number | undefined;
        paymentIntentId: string | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.product = data["product"] !== undefined ? data["product"] : undefined;
                this.amount = data["amount"] !== undefined ? data["amount"] : undefined;
                this.paymentIntentId = data["paymentIntentId"] !== undefined ? data["paymentIntentId"] : undefined;
            }
        }

        static fromJS(data: any): WebPurchase {
            return new WebPurchase(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["product"] = this.product !== undefined ? this.product : undefined;
            data["amount"] = this.amount !== undefined ? this.amount : undefined;
            data["paymentIntentId"] = this.paymentIntentId !== undefined ? this.paymentIntentId : undefined
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new WebPurchase(JSON.parse(json));
        }
    }

    export class PaymentIntentResult {
        status: PaymentIntentStatus | undefined;
        clientSecret: string | undefined;
        paymentMethodId: string | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.status = data["status"] !== undefined ? data["status"] : undefined;
                this.clientSecret = data["clientSecret"] !== undefined ? data["clientSecret"] : undefined;
                this.paymentMethodId = data["paymentMethodId"] !== undefined ? data["paymentMethodId"] : undefined;
            }
        }

        static fromJS(data: any): PaymentIntentResult {
            return new PaymentIntentResult(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["status"] = this.status !== undefined ? this.status : undefined;
            data["clientSecret"] = this.clientSecret !== undefined ? this.clientSecret : undefined;
            data["paymentMethodId"] = this.paymentMethodId !== undefined ? this.paymentMethodId : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new PaymentIntentResult(JSON.parse(json));
        }
    }

    export enum PaymentIntentStatus {
        Success = 1,
        RequiresAction = 2,
        Failed = 3
    }

    export class WebStartRecurringResult {
        isDeviceDeleted: boolean | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.isDeviceDeleted = data["isDeviceDeleted"] !== undefined ? data["isDeviceDeleted"] : undefined;
            }
        }

        static fromJS(data: any): WebStartRecurringResult {
            return new WebStartRecurringResult(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["isDeviceDeleted"] = this.isDeviceDeleted !== undefined ? this.isDeviceDeleted : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new WebStartRecurringResult(JSON.parse(json));
        }
    }

    export class StripeCardData {
        token: string | null | undefined;

        constructor(data?: any) {
            if (data !== undefined) {
                this.token = data["token"] !== undefined ? data["token"] : undefined;
            }
        }

        static fromJS(data: any): StripeCardData {
            return new StripeCardData(data);
        }

        toJS(data?: any) {
            data = data === undefined ? {} : data;
            data["token"] = this.token !== undefined ? this.token : undefined;
            return data;
        }

        toJSON() {
            return JSON.stringify(this.toJS());
        }

        clone() {
            const json = this.toJSON();
            return new StripeCardData(JSON.parse(json));
        }
    }

    export class SwaggerException extends Error {
        message: string;
        status: number;
        response: string;
        result: any;

        constructor(message: string, status: number, response: string, result: any) {
            super();

            this.message = message;
            this.status = status;
            this.response = response;
            this.result = result;
        }
    }


    export var customerAPI = new CustomerAPI.AccountClient(CustomerAPIUrl);
    export var deviceAPI = new CustomerAPI.DevicesClient(CustomerAPIUrl);
    export var subscriptionsAPI = new CustomerAPI.SubscriptionsClient(CustomerAPIUrl);
    export var notificationService = new CustomerAPI.NotificationServiceClient(CustomerAPIUrl);
    export var paymentAPI = new CustomerAPI.PaymentClient(CustomerAPIUrl);

    export function IsLoggedIn(): boolean {
        var tokenExpiration = parseInt(localStorage.getItem("loginTokenExpiration"));
        if (tokenExpiration == undefined || tokenExpiration == null || isNaN(tokenExpiration) || tokenExpiration < new Date().getTime())
            return false;
        else {
            localStorage.setItem("loginTokenExpiration", undefined);
            return true;
        }
    }
    export function login(username: string, password: string, onSuccess?: () => void, onFail?: (exception: string, reason: string) => void) {
        jQuery.ajax({
            crossDomain: true,
            url: CustomerAPIUrl + "/api/users/login",
            method: "POST",
            headers: {
                "content-type": "application/x-www-form-urlencoded",
                "cache-control": "no-cache",
                "x-language": localizer.LangShortCode,
            },
            data: {
                "username": username,
                "password": password
            }
        }).done(function (response) {
            localStorage.setItem("loginToken", response.access_token);
            localStorage.setItem("loginTokenExpiration", (new Date().getTime() + (response.expires_in * 1000)).toString());
            onSuccess();
        }).fail((xhr) => { if (onFail !== undefined) onFail(xhr.status, xhr.responseText); });
    }

    export function RefreshToken(onSuccess?: () => void, onFail?: (exception: string, reason: string) => void) {
        customerAPI.renewToken(token => {
            localStorage.setItem("loginToken", token.access_token);
            localStorage.setItem("loginTokenExpiration", (new Date().getTime() + (token.expires_in * 1000)).toString());
            onSuccess();
        }, (exception, reason) => { if (onFail !== undefined) onFail(exception, reason); });
    }
}